// src/app/core/i18n/translate.pipe.ts
import type { PipeTransform} from '@angular/core';
import { Pipe, inject } from '@angular/core';
import { TranslationService } from './translation.service';

/**
 * TranslatePipe — pipe standalone para traducciones en templates.
 *
 * Uso básico:   {{ 'loans.title' | translate }}
 * Con params:   {{ 'loans.count' | translate: { count: loans.length } }}
 *
 * SEGURIDAD: usar siempre con text binding {{ }}, nunca con [innerHTML].
 * Los valores interpolados son escapados para prevenir XSS en TranslationService.
 *
 * Pure: false porque el idioma puede cambiar en runtime sin cambiar la clave.
 */
@Pipe({
  name: 'translate',
  standalone: true,
  pure: false,   // Necesario para detectar cambios de idioma en runtime
})
export class TranslatePipe implements PipeTransform {
  private readonly translationService = inject(TranslationService);

  transform(key: string, params?: Record<string, string | number>): string {
    if (!key) return '';
    return this.translationService.get(key, params);
  }
}
